import Icon from '../components/Icon.vue'

Icon.register({
  'check-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504 256c0 137-111 248-248 248s-248-111-248-248 111-248 248-248 248 111 248 248zM227.3 387.3l184-184c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-150.1 150.1-70.1-70.1c-6.2-6.2-16.4-6.2-22.6 0l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6l104 104c6.2 6.2 16.4 6.2 22.6 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/check-circle.js
// module id = 1172
// module chunks = 0